
import { Placement } from '@post-office/placements-frontend/jira-for-you-crossflow-solutions';
export default Placement;
